import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../content/utils.js';
import requireAuth from '../lib/requireAuth.jsx';
import withRouterParams from '../lib/withRouterParams.jsx';

import ProjectReportsContainer from '../containers/reports/ProjectReportsContainer.jsx';
import { splitAndMapArrayParam } from './utils/index.js';

const ProjectReports = ({ query, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('projectReports')} | ChangeSync</title>
    </Helmet>
    <ProjectReportsContainer query={query} slug={slug} />
  </>
);

ProjectReports.getInitialProps = ({ query }) => ({
  slug: query.slug,
  query: {
    // Project filters
    parentPortfolioIds: splitAndMapArrayParam(query.parentPortfolioIds, Number),
    portfolioIds: splitAndMapArrayParam(query.portfolioIds, Number),
    projectIds: splitAndMapArrayParam(query.projectIds, Number),
    ownerIds: splitAndMapArrayParam(query.owners, Number), // URL uses 'owners'
    projectStartDate: query.projectStartDate,
    projectEndDate: query.projectEndDate,
    projectStatusIds: splitAndMapArrayParam(query.projectStatusIds, Number),
    archived:
      query.archived === 'true'
        ? true
        : query.archived === 'false'
          ? false
          : undefined,
    projectImpact: splitAndMapArrayParam(query.projectImpact),
    scope: splitAndMapArrayParam(query.scope),
    portfolioMilestoneIds: splitAndMapArrayParam(
      query.portfolioMilestoneIds,
      Number
    ),
    projectMilestoneIds: splitAndMapArrayParam(
      query.projectMilestoneIds,
      Number
    ),

    // Initiative filters
    initiativeStartDate: query.initiativeStartDate,
    initiativeEndDate: query.initiativeEndDate,
    initiativeImpact: splitAndMapArrayParam(query.initiativeImpact),
    initiativeTypes: splitAndMapArrayParam(query.types), // URL uses 'types'
    initiativeCategoryIds: splitAndMapArrayParam(query.categories, Number), // URL uses 'categories'
    survey: query.survey,
    surveyStatuses: splitAndMapArrayParam(query.surveyStatuses),
    surveyStartDate: query.surveyStartDate,
    surveyEndDate: query.surveyEndDate,

    // Participant filters (URL params use 'employees'/'groups', map to 'employeeIds'/'groupIds')
    employeeIds: splitAndMapArrayParam(query.employees, Number),
    groupIds: splitAndMapArrayParam(query.groups, Number),
    organizationStakeholderIds: splitAndMapArrayParam(
      query.organizationStakeholderIds,
      Number
    ),

    // Stakeholder filters
    stakeholderInfluences: splitAndMapArrayParam(query.stakeholderInfluences),
    stakeholderInterests: splitAndMapArrayParam(query.stakeholderInterests),
    stakeholderImpacts: splitAndMapArrayParam(query.stakeholderImpacts),
    stakeholderEngagementFrequencies: splitAndMapArrayParam(
      query.stakeholderEngagementFrequencies
    ),
    stakeholderSupports: splitAndMapArrayParam(query.stakeholderSupports),
  },
});

export default requireAuth(withRouterParams(ProjectReports));
